import {
  AlertEmailsOutput,
  SearchAlertsOutput,
  SearchAlertsQuery,
} from 'switch-shared/modules/crud/alert/alert.dto';

import { baseAPI } from './baseAPI.service';
import { API_METHODS, ENDPOINT_URLS } from './config/apiTags';

export const alertAPI = baseAPI
  .enhanceEndpoints({
    addTagTypes: [ENDPOINT_URLS.ALERT],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      alertFind: builder.query<SearchAlertsOutput, SearchAlertsQuery>({
        query: (params) => ({
          url: `${ENDPOINT_URLS.ALERT}`,
          method: API_METHODS.GET,
          params,
        }),
        providesTags: [ENDPOINT_URLS.ALERT],
      }),

      alertEmails: builder.query<AlertEmailsOutput, { id: string }>({
        query: ({ id }) => ({
          url: `${ENDPOINT_URLS.ALERT}/${id}/emails`,
          method: API_METHODS.GET,
        }),
      }),

      alertDelete: builder.mutation<void, { id: string }>({
        query: ({ id }) => ({
          url: `${ENDPOINT_URLS.ALERT}/${id}`,
          method: API_METHODS.DELETE,
        }),
        invalidatesTags: [ENDPOINT_URLS.ALERT],
      }),
    }),
  });

export const {
  useAlertFindQuery,
  useAlertEmailsQuery,
  useAlertDeleteMutation,
} = alertAPI;
export default alertAPI;
